import { CLEAR_REQUEST_LOG, Loader, PRE_LOAD_SERVICES, UPDATE_API_STATUS } from './constants';

export const showLoader = () => ({ type: Loader.SHOW_LOADER });

export const hideLoader = (dispatch) => {
  if (dispatch) {
    dispatch({ type: Loader.HIDE_LOADER });
  } else {
    return ({ type: Loader.HIDE_LOADER });
  }
  return '';
};

export const apiRequestCompleted = (api) => ({ type: UPDATE_API_STATUS, payload: { [api]: true } });

export const resetAPIStatus = (api) => ({ type: UPDATE_API_STATUS, payload: { [api]: undefined } });

export const updatePreLoadServices = (serviceCollection) => ({ type: PRE_LOAD_SERVICES, payload: { preLoadServices: serviceCollection, ...clearCompletedRequests(serviceCollection) } });

export const clearCompletedRequests = (serviceCollection) => {
  const resetData = (serviceCollection || []).reduce((objRef, nextVal) => ({ ...objRef, [nextVal]: undefined }), {});
  return { completedRequests: resetData };
};

export const clearRequestLog = () => ({ type: CLEAR_REQUEST_LOG });
